import axios from "axios";

const requestExport = ({ id }) => axios.post("reports/export", { id });

const refetchReports = () => axios.post("reports/refetch");

const refetchReportMetric = ({ clientId, params }) =>
  axios.post(`reports/${clientId}/metrics`, params);

export { refetchReports, requestExport, refetchReportMetric };
